module.exports = __webpack_public_path__ + "static/media/ASC August  2020 Top Five_1594821294655.2b96c714.pptx";